import React, { useId } from "react";
import { useLocalization } from '@providers/LocalizationProvider';

interface ConditionOverlayProps {
  visible: boolean;
  showError: boolean;
  checked: boolean;     
  onCheckboxChange: (checked: boolean) => void;
  idPrefix?: string;
}

const ConditionOverlay: React.FC<ConditionOverlayProps> = ({
  visible,
  showError,
  checked,
  onCheckboxChange,
  idPrefix
}) => {
  const rid = useId();
  const base = idPrefix ? String(idPrefix) : `cond-${rid}`;
  const containerId = `${base}-container`;
  const checkboxId  = `${base}-accept`;
  const errorId     = `${base}-error`;

  const { getText } = useLocalization();


  const privacyPolicyUrl = getText('conditions_url_1');  
  const termsConditionsUrl = getText('conditions_url_2');  
  const conditionsText = getText('conditions');
  const clauseText = getText('clause');

  const formattedText = conditionsText.replace(/%1\$s/g, `<a href="${privacyPolicyUrl}">`).replace(/%2\$s/g, `</a>`).replace(/%3\$s/g, `<a href="${termsConditionsUrl}">`);
                                      

  return (
    <div
      id={containerId}
      className="tc mb-3"
      style={{ display: visible ? 'block' : 'none' }}
    >
      {/* Inserisce il testo formattato con i link */}
      <p style={{ fontSize: '13px' }} dangerouslySetInnerHTML={{ __html: formattedText }} />

      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id={checkboxId}
          checked={checked}
         onChange={(e) => onCheckboxChange(e.target.checked)}
          aria-invalid={showError || undefined}
          aria-describedby={showError ? errorId : undefined}
        />
        <label className="form-check-label" htmlFor={checkboxId} style={{ fontSize: "13px" }}>
          {clauseText} {/* Mostra il testo della clausola */}
        </label>
       <div id={errorId} className="invalid-feedback" style={{ display: showError ? "block" : "none" }}>
          {getText("error_conditions")}
        </div>
      </div>
    </div>
  );
};

export default ConditionOverlay;
